import { ContentBlocks, defineBlock, EditableText, InspectorControls } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Ferve Pass Grid",
  icon: "cart",
  category: "embed",
  keywords: ["flexipass", "tickets"],
  tags: ["#subpage"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("tickets/flexipass-grid", (props) => {
  return (
    <>
      <div className="my-8" data-mixpanel-area="Ferve Pass Grid">
        <div className="grid-auto">
          <div className="col-span-12 mb-7">
            <EditableText
              as="h2"
              store="heading"
              className="type-title-l md:type-title-m max-w-[20em] text-balance"
              defaultValue="Buy your Flexipass and save"
            />
          </div>
        </div>
        <div className="grid-auto [&_>_*]:col-span-12 sm:[&_>_*]:col-span-6 md:[&_>_*]:col-span-3 gap-y-grid-gutter">
          <ContentBlocks blocks={props.templateParts?.globalFlexipasses?.contentBlocks} />
        </div>
      </div>
      {env.admin && (
        <InspectorControls>
          <div className="px-4">
            <a
              href="/wp-admin/site-editor.php?postType=wp_template_part"
              style={{ color: "var(--wp-components-color-accent, var(--wp-admin-theme-color, #3858e9))" }}
            >
              Edit passes
            </a>
          </div>
        </InspectorControls>
      )}
    </>
  )
})
